// import { faArrowDown, faArrowUp, faTrash } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { useContext, useEffect, useState } from 'react'
// import ErrorDialog from '../../../../../components/dialogs/ErrorDialog'
import SlideContainerWidget from '../../../../../components/ui/slide_container/SlideContainerWidget'
// import Patient from '../../../../../libs/api/services/Patient'
// import { PatientHistoryProvider } from '../../history/PatientHistoryProvider'
// import PatientProfileCategoryField from '../field/PatientProfileCategoryField'
// import PatientProfileContext from '../PatientProfileProvider'

import { faArrowDown, faArrowUp, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import Patient from "../../../../../libs/api/services/Patient"
import PatientProfileCategoryField from '../field/PatientProfileCategoryField'

// export default function PatientProfileAdminCategories({ categoryID, onStatusChange }) {
//   const { state, execute, reload } = useContext(PatientProfileContext)

//   useEffect(() => {
//     if (state.state === 'RELOAD_CATEGORIES' || state.state === 'READY')
//       execute('LOAD_CATEGORIES_FROM_SERVER', null)
//   }, [state.state])

//   return (
//     <>
//       <ErrorDialog onClose={() => execute('CLEAR_ERROR', {})} error={state.error} />
//       <h3 className='text-center'>Patient Profile Template</h3>
//       <div>{(state.state === 'READY' || state.state === 'RELOAD_CATEGORIES') && state.categories.map((c, ix) => <CategoryLineItem key={`${c.resource.id}-${ix}`} category={c.resource} onStatusChange={onStatusChange} />)}</div>
//     </>
//   )
// }

// const CategoryLineItem = ({ category, onStatusChange }) => {
//   const { execute } = useContext(PatientProfileContext)
//   const [DragId, setDragId] = useState(-10)
//   const [dragOrder, setDragOrder] = useState(-10)

//   const _handleChangeOrder = (categoryID, order) => {
//     if (order < 0) return;
//     execute('CHANGE_CATEGORY_ORDER', { categoryID: categoryID, order: order })
//     setDragId(-10)
//     setDragOrder(-10)
//   }
//   return (<div className='d-flex'>
//     <div
//       style={(dragOrder === category.order) ? { opacity: '0.5', cursor: 'copyMove' } : { cursor: 'move' }}
//       draggable
//       onDragStart={(e) => { e.dataTransfer.effectAllowed = "copyMove"; setDragId(category.id) }}
//       onDragEnter={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; setDragOrder(category.order) }}
//       onDragOver={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; }}
//       onDragEnd={(e) => { _handleChangeOrder(category.id, dragOrder); setDragOrder(-1) }}
//       key={category.id}
//     >
//       <FontAwesomeIcon onClick={(e) => _handleChangeOrder(category.id, category.order - 1)} icon={faArrowUp} />
//       <FontAwesomeIcon onClick={(e) => _handleChangeOrder(category.id, category.order + 1)} icon={faArrowDown} />
//     </div>
//     <div className='container-fluid'>
//       <PatientProfileContainer categoryId={category.id} onStatusChange={(m) => onStatusChange(m)} key={category.id} category={category.groupNme} />
//     </div>
//   </div>)
// }

// const PatientProfileContainer = ({ category, categoryId, onStatusChange }) => {
//   const [clr, setclr] = useState(Math.random())
//   const [open, setOpen] = useState(true)
//   const { state, execute, reload } = useContext(PatientProfileContext)
//   return (
//     <PatientHistoryProvider>
//       <SlideContainerWidget
//         title={category}
//         icon={'pencil'}
//         state={setOpen}
//         className={'bg-secondary-container'}
//         options={
//           <FontAwesomeIcon
//             className='btn' icon={faTrash}
//             onClick={(e) => execute('REMOVE_CATEGORY', categoryId).then((r) => onStatusChange('Category Removed'))}
//           />
//         }
//       >

//         <input defaultValue={category} onChange={(e) => execute('CHANGE_CATEGORY_NAME', { id: categoryId, GroupNme: e.target.value })} className='form-control form-control-sm' />
//         <PatientProfileCategoryEvent categoryId={categoryId} />
//         <h3 className='text-center m-0 p-0 '>Fields</h3>
//         <SlideContainerWidget title={'Add Field'} icon={'plus'} className='shadow' onClose={() => {
//           reload()
//           setclr(Math.random())
//         }}>
//           <PatientProfileCategoryField key={'New Field'} field={{ type: '' }} categoryID={categoryId} rel={clr} />
//         </SlideContainerWidget>
//         {
//           (state.state === 'READY' || state.state === 'SAVING_FIELD_TO_SERVER') && <CategoryDetailsComponent categoryId={categoryId} onStatusChange={onStatusChange} />
//         }
//       </SlideContainerWidget>
//     </PatientHistoryProvider>
//   )
// }

// const CategoryDetailsComponent = ({ categoryId, onStatusChange }) => {
//   const { state, execute, reload } = useContext(PatientProfileContext)
//   const [fields, setFields] = useState()
//   const [dragId, setDragId] = useState('')
//   const [dragOrder, setDragOrder] = useState(-10)

//   useEffect(() => {
//     const load = async () => {
//       setFields(await Patient.LoadFields(categoryId))
//     }
//     // LOAD_CATEGORIES_FROM_SERVER
//     // if(state === 'LOAD_CATEGORIES_FROM_SERVER')
//     load()
//   }, [state])
//   const _handleChangeOrder = (categoryID, id, order) => {
//     if (order < 0) return;
//     execute('CHANGE_CATEGORY_FIELD_ORDER', { categoryID: categoryID, id: id, order: order })
//     setDragOrder(-10)
//   }
//   return <>{fields ? fields.map((f, ix) => {
//     return (
//       <div className='d-flex shadow rounded' key={`li-${f.resource.id}-${ix}`}
//         style={(dragOrder === f.order) ? { opacity: '0.5', cursor: 'copyMove' } : {}}
//         draggable
//         onDragStart={(e) => { e.dataTransfer.effectAllowed = "copyMove"; setDragId(f.id) }}
//         onDragEnter={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; setDragOrder(f.order) }}
//         onDragOver={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; }}
//         onDragEnd={(e) => { _handleChangeOrder(categoryId, dragId, dragOrder); setDragOrder(-10) }}
//       >
//         <div
//           style={{ cursor: 'move' }}
//         >
//           <FontAwesomeIcon onClick={(e) => _handleChangeOrder(categoryId, f.resource.id, f.resource.order - 1)} icon={faArrowUp} />
//           <FontAwesomeIcon onClick={(e) => _handleChangeOrder(categoryId, f.resource.id, f.resource.order + 1)} icon={faArrowDown} />
//         </div>
//         <SlideContainerWidget
//           options={
//             <FontAwesomeIcon
//               className='btn btn-sm ' icon={faTrash}
//               onClick={(e) => execute('REMOVE_CATEGORY_FIELD', { categoryId: categoryId, fieldId: f.resource.id }).then((r) => {
//                 onStatusChange('Field Removed')
//                 reload()
//               }
//               )
//               }
//             />
//           }
//           title={f.resource.value} icon={'pencil'}>
//           <PatientProfileCategoryField field={f.resource} key={f.resource.id} categoryID={categoryId} isNew={false} />
//         </SlideContainerWidget>
//       </div>
//     )
//   }) : <div>Loading Fields</div>}</>
// }


export default function PatientProfileAdminCategories({ categoryID, onStatusChange, active }) {
  const [categories, setCategories] = useState([])

  const reload = async () => setCategories(await Patient.Categories())

  // useEffect(()=)

  useEffect(() => {
    const LOAD_CATEGORIES_FROM_SERVER = async () => {
      setCategories(await Patient.Categories())
    }
    LOAD_CATEGORIES_FROM_SERVER()
  }, [active])
  return <CategoryDragContainer
    categories={categories}
    reload={reload}
    onStatusChange={onStatusChange}
  />
}

const CategoryDragContainer = ({ categories, reload, onStatusChange }) => {
  const [dragOrder, setDragOrder] = useState(-10)

  const _handleChangeOrder = async (categoryID, order) => {
    if (dragOrder < -1 && order < -1) return;
    Patient.ChangeCategoryOrder(categoryID, order ? order : (dragOrder + 1)).then(() => reload())
    setDragOrder(-10)
  }

  return categories.map((c, i) => <CategoryLineItem
    key={c.resource.id}
    reload={reload}
    idx={i}
    category={c.resource}
    onStatusChange={onStatusChange}
    _handleChangeOrder={_handleChangeOrder}
    dragOrder={dragOrder}
    _handleDragOver={setDragOrder}
  />)
}

const CategoryLineItem = ({ category, onStatusChange, idx, _handleChangeOrder, dragOrder, _handleDragOver, reload }) => {
  return (<div className='d-flex'>
    <div
      style={(dragOrder === category.order) ? { opacity: '0.5', cursor: 'copyMove' } : { cursor: 'move' }}
      draggable
      onDragStart={(e) => { e.dataTransfer.effectAllowed = "copyMove"; }}
      onDragEnter={(e) => {
        e.preventDefault(); e.dataTransfer.effectAllowed = "move";
        _handleDragOver(idx)
      }}
      onDragOver={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; }}
      onDragEnd={() => _handleChangeOrder(category.id)}
      key={category.id}
    >
      <FontAwesomeIcon onClick={(e) => _handleChangeOrder(category.id, category.order - 1)} icon={faArrowUp} />
      <FontAwesomeIcon onClick={(e) => _handleChangeOrder(category.id, category.order + 1)} icon={faArrowDown} />
    </div>
    <div className='container-fluid'>
      <PatientProfileContainer onStatusChange={(m) => onStatusChange(m)} key={category.id} category={category} reload={reload} />
    </div>
  </div>)
}


const PatientProfileContainer = ({ category, onStatusChange, reload }) => {
  // const [clr, setclr] = useState(Math.random())
  // const [active, setActive] = useState()
  const [open, setOpen] = useState(false)
  // const { state, execute, reload } = useContext(PatientProfileContext)

  const _handleRemoveCategory = async (categoryId) =>
    Patient.RemoveCategory(categoryId).then(() => { onStatusChange('Category Removed'); reload() })

  const _handleRenameCategory = async (name) => await Patient.UpdateCategory({
    ...category,
    groupNme: name
  })

  return (<>
    <SlideContainerWidget
      title={category.groupNme}
      icon={'pencil'}
      onClose={() => reload()}
      // state={setOpen}
      className={'bg-secondary-container'}
      options={
        <FontAwesomeIcon
          className='btn' icon={faTrash}
          onClick={(e) => _handleRemoveCategory(category.id)}
        />
      }
    >
      <input defaultValue={category.groupNme}
        onBlur={(e) => _handleRenameCategory(e.target.value)}
        className='form-control form-control-sm' />
      <h3 className='text-center m-0 p-0 '>Fields</h3>
      <SlideContainerWidget title={'Add Field'} icon={'plus'} className='shadow' onClose={() => {
        setOpen(!open)
        // reload()
        // setclr(Math.random())
      }}>
        <PatientProfileCategoryField key={'New Field'} field={{ type: '' }} categoryID={category.id} />
      </SlideContainerWidget>
      <PatientProfileCategoryFieldDragContainer categoryId={category.id} onStatusChange={onStatusChange} reload={reload} open={open} />
    </SlideContainerWidget>
  </>
  )
}


const PatientProfileCategoryFieldDragContainer = ({ categoryId, onStatusChange, reload, open }) => {
  const [fields, setFields] = useState()
  const [dragId, setDragId] = useState('')
  const [dragOrder, setDragOrder] = useState(-10)

  useEffect(() => {
    const load = async () => setFields(await Patient.LoadFields(categoryId))
    load()
  }, [categoryId, open])

  const _handleChangeOrder = async (category, item, order) => {
    await Patient.ChangeFieldOrder(item, order ? order : (dragOrder + 1))
    setFields(await Patient.LoadFields(categoryId))
  }

  const _handleRemoveItem = (id) =>
    Patient.RemoveCategoryField(id).then(async () => {
      onStatusChange('Field Removed')
      setFields(await Patient.LoadFields(categoryId))
    })

  return fields ? fields.map((f, ix) => <CategoryDetailsComponent
    key={`CategoryDetailsComponent-${f.resource.id}`}
    detail={f}
    ix={ix}
    _handleChangeOrder={_handleChangeOrder}
    dragId={dragId}
    dragOrder={dragOrder}
    setDragId={setDragId}
    setDragOrder={setDragOrder}
    categoryId={categoryId}
    onRemove={_handleRemoveItem}
  />) : <div>Loading Fields</div>
}

const CategoryDetailsComponent = ({ detail, categoryId, onStatusChange, fields, _handleChangeOrder, dragId, dragOrder, ix, setDragId, setDragOrder, onRemove }) => {

  return <div className='d-flex shadow rounded' key={`li-${detail.resource.id}-${ix}`}
    style={(dragOrder === detail.order) ? { opacity: '0.5', cursor: 'copyMove' } : {}}
    draggable
    onDragStart={(e) => { e.dataTransfer.effectAllowed = "copyMove"; setDragId(detail.resource.id) }}
    onDragEnter={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; setDragOrder(ix) }}
    onDragOver={(e) => { e.preventDefault(); e.dataTransfer.effectAllowed = "move"; }}
    onDragEnd={(e) => { _handleChangeOrder(categoryId, dragId); setDragOrder(-10) }}
  >
    <div
      style={{ cursor: 'move' }}
    >
      <FontAwesomeIcon onClick={(e) => _handleChangeOrder(categoryId, detail.resource.id, detail.resource.order - 1)} icon={faArrowUp} />
      <FontAwesomeIcon onClick={(e) => _handleChangeOrder(categoryId, detail.resource.id, detail.resource.order + 1)} icon={faArrowDown} />
    </div>
    <SlideContainerWidget
      options={
        <FontAwesomeIcon
          className='btn btn-sm ' icon={faTrash}
          onClick={(e) => onRemove(detail.resource.id)}
        />
      }
      title={detail.resource.value} icon={'pencil'}>
      <PatientProfileCategoryField field={detail.resource} key={detail.resource.id} categoryID={categoryId} isNew={false} />
    </SlideContainerWidget>
  </div>
}